var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.131,
    height: 15.968,
    viewBox: "0 0 9.131 15.968",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-down",
    "data-name": "Icon ionic-ios-arrow-down",
    d: "M14.174,17.624l6.038-6.042a1.136,1.136,0,0,1,1.612,0,1.151,1.151,0,0,1,0,1.616l-6.841,6.846a1.139,1.139,0,0,1-1.574.033L6.52,13.2a1.141,1.141,0,0,1,1.612-1.616Z",
    transform: "translate(-11.246 22.155) rotate(-90)",
    fill: "#80838e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightarrow);
export default __webpack_public_path__ + "static/media/rightarrow.12fe5b44d4b4dafb66645770391fae44.svg";
export { ForwardRef as ReactComponent };